import React from 'react'

function Loader({message}) {
    return (
        <div className="ajax-loader-cont">
            <div className="ajax-loader-bg show"></div>
            <div className="ajax-loader show">
                <span className="dot"></span>
                <span className="dot"></span>
                <span className="dot"></span>
                <span className="dot"></span>
                <span className="dot"></span>
                {message?<p>{message}</p>:<></>}
            </div>
        </div>
    )
}

export default Loader
